import React from 'react'
import { Link, useOutletContext } from 'react-router-dom';

function GroupCard(group) {
    const { user,token } = useOutletContext();
    const [status, setStatus] = React.useState(group.group.user_status);
  const sentGroupRequest = () => {
    fetch('/api/join-group-request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        group_id: group.group.id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setStatus(2);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
        <div className="col-md-6 col-sm-6 pe-2 ps-2 " >
  <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
    <Link to={`/group/${group.group.id}`}  >
    <div className="card-body position-relative h100 bg-image-cover bg-image-center" style={{backgroundImage: 'url(images/campus-bg-min.jpg)', backgroundSize: 'cover', backgroundPosition: 'bottom'}} />
    </Link>
    <div className="card-body d-block w-100 pl-10 pe-4 pb-4 pt-0 text-left position-relative">
    
      <div className="clearfix" />
      <h4 className="fw-700 font-xsss mt-3 mb-1">
        <Link to={`/group/${group.group.id}`} className="text-grey-900" >
        {group.group.name}
        </Link>
        </h4>
      <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3">{group.group.member_count > 5 ? `${group.group.member_count}+ Members` : ``}</p>
      <span className="position-absolute right-15 top-0 d-flex align-items-center">
        {
          status == 0 ?
          <a href="#" className="text-center p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white" onClick={sentGroupRequest}>Join Group</a> :
          <span></span>
        }
        {
          status == 1 ?
          <span className="text-center p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white">Joined</span> :
          <span></span>
        }
        {
          status == 2 ?
          <span className="text-center p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white">Requested</span> :
          <span></span>
        }
      </span>
    </div>
  </div>
</div>
  )
}

export default GroupCard